import React from "react";
import { useLoaderData } from "react-router-dom";
import SingleCategory from "./SingleCategory";

const Category = () => {
  const tutorials = useLoaderData();
//   console.log(tutorials);
  return (
    <div className="grid md:grid-cols-2 p-10 gap-y-6 sm:grid-cols-1">
      {tutorials.map((tutorial) => <SingleCategory key={tutorial.id} tutorial={tutorial}></SingleCategory>)}
    </div>
  );
};

export default Category;
